export type SavedItemType = 'RESOURCE' | 'HUB' | 'PROGRAM';

export const DEFAULT_SAVED_FOLDER_NAME = 'Reading list';
export const LOCAL_DEFAULT_FOLDER_ID = 'local-default';

export interface SavedItem {
  id: string;
  type: SavedItemType;
  itemKey: string;
  postId: number | null;
  hubId: string | null;
  programId: string | null;
  title: string;
  slug: string;
  folderId: string;
  sortOrder: number;
  createdAt: string;
}

export interface SavedFolder {
  id: string;
  name: string;
  isDefault: boolean;
  sortOrder: number;
  items: SavedItem[];
}

export function placeholderDefaultFolder(): SavedFolder {
  return {
    id: LOCAL_DEFAULT_FOLDER_ID,
    name: DEFAULT_SAVED_FOLDER_NAME,
    isDefault: true,
    sortOrder: 0,
    items: [],
  };
}

export interface SavedLibrary {
  folders: SavedFolder[];
}

export interface SaveItemInput {
  type: SavedItemType;
  title: string;
  slug: string;
  postId?: number;
  hubId?: string;
  programId?: string;
  folderId?: string;
}

export function savedItemKey(type: SavedItemType, id: number | string): string {
  if (type === 'RESOURCE') return `resource:${id}`;
  if (type === 'HUB') return `hub:${id}`;
  return `program:${id}`;
}
